var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7066_2078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 1.6665L10.5974 1.67234C10.7834 1.69427 10.9566 1.77824 11.0891 1.91068C11.2215 2.04312 11.3055 2.21632 11.3274 2.40234L11.3333 2.49984V5.83317L11.3374 5.95817C11.3672 6.35498 11.538 6.72803 11.819 7.00986C12.0999 7.2917 12.4724 7.46372 12.8691 7.49484L12.9999 7.49984H16.3333L16.4308 7.50567C16.6168 7.52761 16.79 7.61157 16.9224 7.74401C17.0549 7.87646 17.1388 8.04966 17.1608 8.23567L17.1666 8.33317V15.8332C17.1666 16.4708 16.923 17.0844 16.4855 17.5484C16.0481 18.0123 15.4498 18.2916 14.8133 18.329L14.6666 18.3332H6.33325C5.69558 18.3332 5.08199 18.0896 4.61803 17.6521C4.15408 17.2146 3.87483 16.6164 3.83742 15.9798L3.83325 15.8332V4.1665C3.83322 3.52883 4.07686 2.91524 4.51432 2.45129C4.95179 1.98733 5.55001 1.70808 6.18659 1.67067L6.33325 1.6665H10.4999Z",
    fill: "#A0AABB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3334 5.83319H13.0001L12.9993 2.49902L16.3334 5.83319Z",
    fill: "#A0AABB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7066_2078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.e0f4a91549a07c7550af2a3c526d742e.svg";
export { ForwardRef as ReactComponent };